import { SET_CASH_PAYMENT, SET_SPECIFIC_CASH_PAYMENT } from "../Types/CashPaymentTypes";
const initialState = {
    allCashPayment: [],
    specificCashPayment: {},
}

const CashPaymentReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CASH_PAYMENT:
            return { ...state, allCashPayment: action.payLoad };
        case SET_SPECIFIC_CASH_PAYMENT:
            return { ...state, specificCashPayment: action.payLoad };
        default:
            return state;
    }
}
export default CashPaymentReducer;